import { atom } from "recoil";
import {
  Artist,
  AudioPair,
  BrewingTransaction,
  Device,
  DeviceLog,
  Guide,
  PushNotificationLog,
  Short,
  Song,
  SongRequest,
  Toast,
  Token,
  User,
} from "../types/type";

export const songListState = atom<Song[]>({
  key: "songListState",
  default: [],
});

export const artistListState = atom<Artist[]>({
  key: "artistListState",
  default: [],
});

export const shortListState = atom<Short[]>({
  key: "shortListState",
  default: [],
});

export const userListState = atom<User[]>({
  key: "userListState",
  default: [],
});

export const songRequestListState = atom<SongRequest[]>({
  key: "songRequestListState",
  default: [],
});

export const homebrewRecommendedSongListState = atom<Song[]>({
  key: "homebrewRecommendedSongList",
  default: [],
});

export const tokenListState = atom<Token[]>({
  key: "tokenListState",
  default: [],
});

export const deviceListState = atom<Device[]>({
  key: "deviceListState",
  default: [],
});

export const deviceLogListState = atom<DeviceLog[]>({
  key: "deviceLogListState",
  default: [],
});

export const bigQueryAccessTokenState = atom<string>({
  key: "bigQueryAccessTokenState",
  default: "",
});

export const pushNotificationLogListState = atom<PushNotificationLog[]>({
  key: "pushNotificationLogListState",
  default: [],
});

export const toastListState = atom<Toast[]>({
  key: "toastListState",
  default: [],
});

export const totalThumbnailUrlListState = atom<{ [key: string]: string[] }>({
  key: "totalThumbnailUrlListState",
  default: {},
});
export const guideListState = atom<Guide[]>({
  key: "guideListState",
  default: [],
});

export const loadedAudioPairState = atom<AudioPair | null>({
  key: "loadedAudioPairState",
  default: null,
});

export const loadedBrewingTransactionState = atom<BrewingTransaction | null>({
  key: "loadedBrewingTransactionState",
  default: null,
});
